import {
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from "@mui/material";
  import _ from "lodash";
  import React from "react";

import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
import { useStyle } from "../style";
  const ModalTable = ({tableHeadData , tableBodyData,setOpen,data}) => {
    console.log(data,"view data")
    console.log(tableBodyData,"tableBodyData");
    
 const classes = useStyle()
 const location = useLocation()
 const currentPath = location.pathname;
 const totalAmount = tableBodyData.reduce((acc, val) => acc + parseFloat(val.amount), 0);
 const totalQty = tableBodyData.reduce((acc, val) => acc + parseFloat(val.Qty), 0);

    return ( 
      <Grid sx={{ backgroundColor: "#fff",padding:"10px",maxHeight:"500px" ,overflowY:"auto"}}>
        <div className="flex justify-end">
          {/* {data && 
          <Grid className="my-1">
            <Typography sx={{marginBlock:.5}}>Bill No : <strong>{data.documentNo}</strong></Typography>
            <Typography>Bill Date : <strong>{data.documentDate}</strong></Typography>
          </Grid>
          }
          {currentPath == "/reports/outletSalesReport" && data &&
          <>
            <div className="flex my-1" style={{flexDirection:"column"}}>
            <Typography >Sales Man : <strong>{data.sales_man_name}</strong> - <strong>{data.sales_man_code}</strong> </Typography>
             <Typography>Payment Mode : <strong>{data.mode}</strong></Typography>
          </div>
          </>
          } */}
          <IconButton size="small" sx={{marginBlockEnd:2,}} onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <TableContainer className={classes.tblRoot} >
          <Table className={classes.table}>
            <TableHead className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
              <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
                {tableHeadData.map((item) => (
                  <TableCell className={classes.tblCell} sx={{color:"#fff"}} key={item.id}>{item.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
        {tableBodyData && tableBodyData.map((val) => (
              <>
                  <TableRow className={classes.tablrow}  key={val.id}>
                <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.sNo}</TableCell>
                <TableCell>{val.category_name}</TableCell>
                <TableCell>{val.subcategory_name}</TableCell>
                <TableCell>{val.Qty}</TableCell>
                <TableCell>{val.minqty}</TableCell>
                <TableCell>{val.maxqty}</TableCell>
                <TableCell>{val.permonth_target}</TableCell>
                <TableCell>{val.threemonth_target}</TableCell>
                <TableCell>{val.avgqtylast3months}</TableCell>
               <TableCell  sx={{textAlign:"right !important" , fontWeight:600}}>{val.amount}</TableCell>
              </TableRow>
              </>
            ))}


            </TableBody>
          </Table>
        </TableContainer>
        
        <Grid className="flex justify-between">
     <Grid>
     <Typography sx={{textAlign:"end",padding:1}}>Total Qty : <strong>{Math.round(totalQty)}</strong></Typography>

            </Grid>
        <Grid>
 <Typography sx={{textAlign:"end",padding:1}}>Total Amount : <strong>{Math.round(totalAmount)}</strong></Typography>
        </Grid>
        </Grid>
        

      </Grid>
    );
  };
  
  export default ModalTable;